import PropTypes from "prop-types";
import React from "react";

import {splitAddress} from "utils";
import {Destination} from "v2/api/Records";

const DestinationAddress = (props) => {
  const {
        className,
        crmLink,
        data: {address: rawAddress, house, title},
        sidebar,
    } = props;
  if (!rawAddress && !house || rawAddress === title) {
    return null;
  }

  let content;
  if (sidebar) {
    let firstLine;
    let secondLine;
    if (house) {
      firstLine = house.address;
      secondLine = `${house.city}, ${house.state} ${house.zipCode}`;
    } else {
      const [address, city, state, zipCode] = splitAddress(rawAddress);
      firstLine = address;
      secondLine = `${city}, ${state} ${zipCode}`.trim();
    }
    content = [firstLine, <br key="break" />, secondLine];
  } else {
    content = rawAddress;
  }

  if (!crmLink || !house) {
    return <span className={className}>{content}</span>;
  }

  return (
    <a
      className={className}
      href={`${process.env.CRM_URL}/overview/${house.id}`}
      rel="noopener noreferrer"
      target="_blank">
      {content}
    </a>
  );
};

DestinationAddress.defaultProps = {
  crmLink: false,
  sidebar: false,
};
DestinationAddress.propTypes = {
  className: PropTypes.string,
  crmLink: PropTypes.bool,
  data: PropTypes.instanceOf(Destination).isRequired,
  sidebar: PropTypes.bool,
};

export default DestinationAddress;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/DestinationAddress.js
 **/